import { put, select, takeLatest } from 'redux-saga/effects'
import { getPnMedicationSelector } from '../selectors/pnMedication.selector'
import { setAddMedicationAdministeredData } from '../store/pnMedication.actions'
import { PnMedicationConstants } from '../store/pnMedication.constants'
import { IPnMedicationState } from '../store/pnMedication.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { cloneDeep } from 'lodash'

export function* setDose() {
  const pnMedicationState: IPnMedicationState = yield select(getPnMedicationSelector)
  try {
    const { dose, pnMedication, addMedicationAdministeredData } = pnMedicationState
    const selectedMedicationIndex = addMedicationAdministeredData?.findIndex(
      (medication) => medication.id === pnMedication?.id
    )
    if (selectedMedicationIndex > -1) {
      const addMedicationAdministeredDataClone = cloneDeep(addMedicationAdministeredData)
      addMedicationAdministeredDataClone[selectedMedicationIndex].dose = dose
      yield put(setAddMedicationAdministeredData(addMedicationAdministeredDataClone))
    }
  } catch (e) {
    yield put(throwPcrException(`PN Medication setDose() error: ${e}`))
  }
}

export function* setDoseSaga() {
  yield takeLatest([PnMedicationConstants.SET_DOSE], performWithMutexHOG, setDose)
}
